if (!customElements.get('product-finder')) {
  customElements.define(
    'product-finder',
    class ProductFinder extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      onSubmit(event) {
        event.preventDefault();
        window.location.assign(this.buildUrl());
      }

      buildUrl() {
        const age = this.querySelector('[data-finder-age]')?.selectedOptions[0];
        const price = this.querySelector('[data-finder-price]')?.selectedOptions[0];

        // La edad lleva a su colección; sin edad (o sin colección) se buscan todos los productos
        const url = new URL(age?.dataset.url || this.form.getAttribute('action'), window.location.origin);

        if (price?.dataset.min) url.searchParams.set('filter.v.price.gte', price.dataset.min);
        if (price?.dataset.max) url.searchParams.set('filter.v.price.lte', price.dataset.max);

        return url.toString();
      }
    }
  );
}
